exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inputTitle{font-style:normal;font-weight:400;font-size:24px;line-height:29px;padding-bottom:5vh}.errorBox{min-height:30vh}.error{color:red}input{text-align:center;border-radius:30px!important;min-height:41px}.btn-primary{border-radius:56px;min-width:150px;min-height:50px;font-size:18px;-webkit-box-shadow:5px 5px 5px 0 rgba(0,0,0,.75);-moz-box-shadow:5px 5px 5px 0 rgba(0,0,0,.75);box-shadow:5px 5px 5px 0 rgba(0,0,0,.75)}.btn-primary:disabled{-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;background-color:#aaa;border-color:#aaa}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-99e957aa","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/InputSerialNumber.vue
// module id = 311
// module chunks = 0